import { Injectable } from '@angular/core';
// import { User, Car, Service } from './models/Models'
import { Texts } from './models/Texts';
import { Http, HttpModule, Headers, RequestOptions, Response } from '@angular/http';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
// import { AppDialogComponentDialog } from './app-dialog/app-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpClient } from '@angular/common/http';
// import { ErrorDialogComponent } from '../app/error-dialog/error-dialog.component'

declare const L: any;
let marker: any;
let myMap: any;

@Injectable({
  providedIn: 'root'
})
export class PublicService {
  public APICalls: any = {};
  public Authorization: string = "";
  public User: any = {};
  // public ApiUrl: String = "http://gamecraft.ce.aut.ac.ir";z0
  public ApiUrl: String = "https://wastenapp.ir/back-end/wastenapp";
  // public Email: String = "";
  public PhoneNumber: string = "";
  public PhoneNumberAgain: string = "";
  public Password: String = "";
  public namesignin: String = "elahe";
  Texts: Texts = new Texts();
  // public Token: String = "";
  public logedIn: string = "false";
  public fileName: string = "";
  public code1: string = "";
  public code2: string = "";
  public code3: string = "";
  public code4: string = "";
  public code5: string = "";
  public code6: string = "";
  public name: string = "";
  public email: string = "";
  public token: any;
  public location: string = "";
  public money: string = "";
  public shoe: string = "";
  public rice: string = "";
  public plastic: string = "";
  public bread: string = "";
  public cpu: string = "";
  public paper: string = "";
  public cannedfood: string = "";
  public bottle: string = "";
  public drywaste: string = "";
  public shaba: string = "";
  public moneyKifePul: string = "";
  public moneyCharity: string = "";
  public inv_code: string = "";

  // public file: File;
  Mockup() {



  }




  constructor(private httpClient: HttpClient, private http: Http, public dialog: MatDialog, public snackbar: MatSnackBar) {
    // this.Authorization = localStorage.getItem("Authorization");
    this.token = localStorage.getItem('tokenWaste');

    this.logedIn = localStorage.getItem('logedInWaste')!;
    if (this.logedIn == null) {
      this.logedIn = "false";
    }
    // if (this.token != null) {
    //   this.logedIn = true;
    // }
    // console.log("ssssssss");

    // console.log(this.logedIn);
    // this.dialog..PublicService=this;
    // this.Mockup();
    this.Texts.Init();
  }

  private extractData(res: Response, that: any) {
    if (res.status < 200 || res.status >= 300) {
      throw new Error('Bad response status: ' + res.status);
    }


    let body = res.json();

    // if (body.message) {
    //   that.DisplaySuccessDialog(body.message);

    // }

    if (body.error) {
      that.DisplayErrorDialog(body.message);
      Promise.reject(body.error);
    } else {
      return body || {};
    }

  }
  private extractData2(res: Response) {
    if (res.status < 200 || res.status >= 300) {
      throw new Error('Bad response status: ' + res.status);
    }
    let body = res.json();
    return body || {};
  }
  private handleError(error: any) {

    // In a real world app, we might send the error to remote logging infrastructure
    let errMsg = JSON.parse(error._body);//error.message || 'Server error';

    console.error(errMsg); // log to console instead
    return Promise.reject(errMsg);
  }

  // UpdateImage(): Promise<any>{
  //   var that = this;
  //   this.APICalls.UpdateImage = true;
  //   let body = JSON.stringify({
  //     "profile": this.fileName
  //   });
  //   let headers = new Headers({
  //     'Content-Type': 'application/json',
  //     'Authorization': 'Bearer ' + this.Authorization
  //   });
  //   let options = new RequestOptions({ headers: headers });
  //   let ret: Promise<any> = this.http.put(this.ApiUrl + '/api/users/profile/update/', body, options)
  //   .toPromise()
  //   .then((r) => this.extractData(r, this))
  //   .catch(this.handleError);

  // ret.then(r => {
  //   this.APICalls.SignUp = false;
  //   console.log(r);
  // }).catch(e => {
  //   this.APICalls.SignUp = false;
  // //  that.snackbar.openFromComponent(ErrorDialogComponent, { duration: 2000, data: e.message, panelClass: ['snackbar'], verticalPosition: 'top', direction: 'rtl' });
  // });
  // return ret;
  // }

  login(): Promise<any> {
    this.APICalls.login = true;
    // console.log(this.token);
    let body = JSON.stringify({
      "mobile": this.PhoneNumber,
    });
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });
    let ret: Promise<any> = this.http.post(this.ApiUrl + '/api/v1/mobile/send-number', body, options)
      .toPromise()
      .then((r) => this.extractData(r, this))
      .catch(this.handleError);

    ret.then(r => {
      this.APICalls.login = false;
    }).catch(e => {
      this.APICalls.login = false;
    });
    return ret;
  }

  login2(): Promise<any> {
    // this.PhoneNumberAgain = localStorage.getItem("phoneDriver")!;
    localStorage.setItem("aKarbar", "true");
    // this.PhoneNumber = localStorage.getItem("phoneDriver")!;
    // console.log("/////////////////");

    // console.log(this.PhoneNumberAgain);

    this.APICalls.login2 = true;
    // console.log(this.tokenDriver);
    let body = JSON.stringify({
      "mobile": this.PhoneNumberAgain,
    });
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });
    let ret: Promise<any> = this.http.post(this.ApiUrl + '/api/v1/mobile/send-number', body, options)
      .toPromise()
      .then((r) => this.extractData(r, this))
      .catch(this.handleError);

    ret.then(r => {
      this.APICalls.login2 = false;
    }).catch(e => {
      this.APICalls.login2 = false;
    });
    return ret;
  }


  sixdigit(): Promise<any> {

    this.APICalls.sixdigit = true;
    let body = JSON.stringify({
      "mobile": this.PhoneNumber,
      "code": this.code1 + this.code2 + this.code3 + this.code4 + this.code5 + this.code6,
    });
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });
    let ret: Promise<any> = this.http.post(this.ApiUrl + '/api/v1/mobile/send-confirmation-code', body, options)
      .toPromise()
      .then((r) => this.extractData(r, this))
      .catch(this.handleError);

    ret.then(r => {
      this.APICalls.sixdigit = false;
      console.log(r);
      // this.token = r.token;
      localStorage.setItem("tokenWaste", r.token);
      console.log(this.token);
      this.token = localStorage.getItem('tokenWaste');
      if (this.token != null) {
        this.logedIn = "true";
        localStorage.setItem("logedInWaste", "true");
      }
    }).catch(e => {
      this.APICalls.sixdigit = false;
    });
    return ret;
  }

  sixdigit2(): Promise<any> {

    // this.PhoneNumberAgain = localStorage.getItem("phoneDriver")!;

    // console.log(this.PhoneNumber);
    // console.log(this.code1 + this.code2 + this.code3 + this.code4 + this.code5 + this.code6);
    this.APICalls.sixdigit2 = true;
    let body = JSON.stringify({
      "mobile": this.PhoneNumberAgain,
      "code": this.code1 + this.code2 + this.code3 + this.code4 + this.code5 + this.code6,
    });
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });
    let ret: Promise<any> = this.http.post(this.ApiUrl + '/api/v1/mobile/send-confirmation-code', body, options)
      .toPromise()
      .then((r) => this.extractData(r, this))
      .catch(this.handleError);

    ret.then(r => {
      this.APICalls.sixdigit2 = false;
      console.log(r);
      // this.token = r.token;
      localStorage.setItem("tokenWaste", r.token);
      console.log(this.token);
      this.token = localStorage.getItem('tokenWaste');
      if (this.token != null) {
        this.logedIn = "true";
        localStorage.setItem("logedInWaste", "true");
      }
    }).catch(e => {
      this.APICalls.sixdigit2 = false;
    });
    return ret;
  }

  signin(): Promise<any> {

    // console.log("hala hala hala");
    this.token = localStorage.getItem('tokenWaste');
    // console.log(this.token);


    this.APICalls.signin = true;
    let body = JSON.stringify({
      "email": this.email,
      "name": this.name,
      "api_token": this.token,
      "inv_code": this.inv_code,
    });
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });
    let ret: Promise<any> = this.http.post(this.ApiUrl + '/api/v1/user/sign-up', body, options)
      .toPromise()
      .then((r) => this.extractData(r, this))
      .catch(this.handleError);

    ret.then(r => {
      this.APICalls.signin = false;
    }).catch(e => {
      this.APICalls.signin = false;
    });
    return ret;
  }

  getProfile(): Promise<any> {
    console.log(this.token);
    this.APICalls.getProfile = true;
    let body = JSON.stringify({
      "api_token": this.token,
    });
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });
    let ret: Promise<any> = this.http.post(this.ApiUrl + '/api/v1/user/profile', body, options)
      .toPromise()
      .then((r) => this.extractData(r, this))
      .catch(this.handleError);

    ret.then(r => {
      this.APICalls.getProfile = false;
    }).catch(e => {
      this.APICalls.getProfile = false;
    });
    return ret;
  }


  updateProfile(): Promise<any> {
    this.APICalls.updateProfile = true;
    let body = JSON.stringify({
      "api_token": this.token,
      "name": this.name,
      "email": this.email,
    });
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });
    let ret: Promise<any> = this.http.post(this.ApiUrl + '/api/v1/user/update-profile', body, options)
      .toPromise()
      .then((r) => this.extractData(r, this))
      .catch(this.handleError);

    ret.then(r => {
      this.APICalls.updateProfile = false;
    }).catch(e => {
      this.APICalls.updateProfile = false;
    });
    return ret;
  }

  makeOrder(money: any, cpu: any, rice: any, plastic: any, bread: any, paper: any, can: any,
     bottle: any, dry: any, shoes: any, iron: any, mes: any, chodan: any, pet: any, basket: any, lak: any,
     alSabok: any, alSangin: any): Promise<any> {

    // console.log(this.location);

    // console.log(this.token);
    // console.log(dry);
    this.APICalls.makeOrder = true;
    let body = JSON.stringify({
      "api_token": this.token,
      "location": this.location,
      "money": money,
      "shoe": shoes,
      "rice": rice,
      "plastic": plastic,
      "bread": bread,
      "cpu": cpu,
      "paper": paper,
      "canned-food": can,
      "bottle": bottle,
      "dry-waste": dry,
      "iron": iron,
      "mes": mes,
      "chodan": chodan,
      "pet": pet,
      "basket": basket,
      "lak": lak,
      "al_sabok": alSabok,
      "al_sangin": alSangin,

    });
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });
    let ret: Promise<any> = this.http.post(this.ApiUrl + '/api/v1/order', body, options)
      .toPromise()
      .then((r) => this.extractData(r, this))
      .catch(this.handleError);

    ret.then(r => {
      this.APICalls.makeOrder = false;
    }).catch(e => {
      this.APICalls.makeOrder = false;
    });
    return ret;
  }

  choosService(): Promise<any> {

   this.APICalls.choosService = true;
   let body = JSON.stringify({
     "api_token": this.token,
     "location": this.location,
   });
   let headers = new Headers({
     'Content-Type': 'application/json'
   });
   let options = new RequestOptions({ headers: headers });
   let ret: Promise<any> = this.http.post(this.ApiUrl + '/api/v1/order', body, options)
     .toPromise()
     .then((r) => this.extractData(r, this))
     .catch(this.handleError);

   ret.then(r => {
     this.APICalls.choosService = false;
   }).catch(e => {
     this.APICalls.choosService = false;
   });
   return ret;
 }


  getOrder(): Promise<any> {


    // console.log(this.token);
    this.APICalls.getOrder = true;
    let body = JSON.stringify({
      "api_token": this.token,
    });
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });
    let ret: Promise<any> = this.http.post(this.ApiUrl + '/api/v1/user/orders', body, options)
      .toPromise()
      .then((r) => this.extractData(r, this))
      .catch(this.handleError);

    ret.then(r => {
      this.APICalls.getOrder = false;
    }).catch(e => {
      this.APICalls.getOrder = false;
    });
    return ret;
  }


  getLocation(): Promise<any> {
    // const lat = (e.latlng.lat);
    // const lng = (e.latlng.lng);
    // const newLatLng = new L.LatLng(lat, lng);
    // marker.setLatLng(newLatLng);


    this.APICalls.onMapClick = true;
    // let body = JSON.stringify({
    // });
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });
    let ret: Promise<any> = this.http.get(`https://api.neshan.org/v2/reverse?lat=36.419279&lng=54.964772`, options)
      .toPromise()
      .then((r) => this.extractData(r, this))
      .catch(this.handleError);

    ret.then(r => {
      this.APICalls.onMapClick = false;
    }).catch(e => {
      this.APICalls.onMapClick = false;
    });
    return ret;
  }



  giveMoneyToUser(): Promise<any> {


    // console.log(this.token);
    this.APICalls.giveMoneyToUser = true;
    let body = JSON.stringify({
      "api_token": this.token,
      "money": this.moneyKifePul,
      "shaba": this.shaba,
    });
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });
    let ret: Promise<any> = this.http.post(this.ApiUrl + '/api/v1/user/give-money', body, options)
      .toPromise()
      .then((r) => this.extractData(r, this))
      .catch(this.handleError);

    ret.then(r => {
      this.APICalls.giveMoneyToUser = false;
    }).catch(e => {
      this.APICalls.giveMoneyToUser = false;
    });
    return ret;
  }

  charityMoney(): Promise<any> {


    // console.log(this.token);
    this.APICalls.charityMoney = true;
    let body = JSON.stringify({
      "api_token": this.token,
      "money": this.moneyCharity,
    });
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });
    let ret: Promise<any> = this.http.post(this.ApiUrl + '/api/v1/user/charity', body, options)
      .toPromise()
      .then((r) => this.extractData(r, this))
      .catch(this.handleError);

    ret.then(r => {
      this.APICalls.charityMoney = false;
    }).catch(e => {
      this.APICalls.charityMoney = false;
    });
    return ret;
  }

  cancelOrder(id:any): Promise<any> {
    this.APICalls.updateProfile = true;
    let body = JSON.stringify({
      "api_token": this.token,
      "order_id": id,
    });
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });
    let ret: Promise<any> = this.http.post(this.ApiUrl + '/api/user/del-order', body, options)
      .toPromise()
      .then((r) => this.extractData(r, this))
      .catch(this.handleError);

    ret.then(r => {
      this.APICalls.cancelOrder = false;
    }).catch(e => {
      this.APICalls.cancelOrder = false;
    });
    return ret;
  }



}
